import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router';

export function useClearLocationState() {
  const navigate = useNavigate();
  const { state } = useLocation();

  return useCallback(
    (keyToRemove?: string) => {
      let newState: any = { ...state };
      if (keyToRemove) {
        delete newState[keyToRemove];
      } else {
        newState = undefined;
      }

      navigate(window.location.pathname + window.location.search, {
        replace: true,
        state: newState,
      });
    },
    [navigate, state]
  );
}
